<script>
    import {video_store} from "./Utils/stores";
    import Debug from "./Utils/Debug.svelte";
    import PlaylistTile from "./PlaylistTile.svelte";
    import CategoryContainer from "./CategoryContainer.svelte";
    import CategoryContainerHeader from "./CategoryContainerHeader.svelte";
    import CategoryContainerBody from "./CategoryContainerBody.svelte";
    import CategorySidebar from "./CategorySidebar.svelte";
    import CategorySidebarTitle from "./CategorySidebarTitle.svelte";
    import CategorySidebarDescription from "./CategorySidebarDescription.svelte";
    import CategoryMainPanel from "./CategoryMainPanel.svelte";
    import CategoryGrid from "./CategoryGrid.svelte";

    let showall = false;
    function showAll() {showall = true;}

    $: if($video_store.playlists.length < 7) {showall = true;}else{showall = false;}

</script>

<style>
    button.btn {
        border-radius: 5rem;
        border:solid 1px #ccc;
        color: #333;
        outline: none;
        background: #fff;
        z-index: 10;
    }

    .borderline {
        position: relative;
        top:-36px;
        z-index: 2;
    }
</style>

<CategoryContainer>
    <CategoryContainerHeader>
    </CategoryContainerHeader>
    <CategoryContainerBody>
        <CategorySidebar>
            <CategorySidebarTitle>
                Learning Paths
            </CategorySidebarTitle>
            <CategorySidebarDescription>
                Follow along with a set of videos to learn specific features of the software, or to achieve a particular goal.
            </CategorySidebarDescription>
        </CategorySidebar>
        <CategoryMainPanel>
            <CategoryGrid>
                {#each $video_store.playlists.slice(0,6) as playlist (playlist._id)}
                    <PlaylistTile playlist= {playlist} />
                {/each}

                {#if showall}
                        {#each $video_store.playlists.slice(6) as playlist (playlist._id)}
                            <PlaylistTile playlist= {playlist} />
                        {/each}
                {/if}
            </CategoryGrid>
            {#if !showall}
                <div class="vec-mt-12">
                    <hr>
                    <p class="vec-w-full vec--mt-6 vec-flex vec-justify-center rounded-circle">
                        <button class="vec-btn" role="button" aria-expanded="false" aria-controls="collapseExamples"
                                on:click={showAll}>
                            Show All Playlists
                        </button>
                    </p>
                    <div class="vec-w-full border-top borderline"></div>
                </div>
            {/if}

        </CategoryMainPanel>
    </CategoryContainerBody>
</CategoryContainer>

